<div class="plate" [class]="color()">
	<div class="shadow"></div>
	<div class="border"></div>
	<div class="frame"></div>
	<div class="symbol symbol-top"></div>
	<div class="label">
		<div class="label-bg"></div>
		<span>{{ label() }}</span>
	</div>
	<div class="symbol symbol-bottom"></div>
	<div class="panning-light"></div>
</div>
